import { render, staticRenderFns } from "./InvitationListItem.vue?vue&type=template&id=09bb7274&lang=pug"
import script from "./InvitationListItem.vue?vue&type=script&lang=js"
export * from "./InvitationListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports